import { StaticImage } from "gatsby-plugin-image"
import * as React from "react"

export const Footer = () => {
  const [theme, setTheme] = React.useState<string | null>("")
  React.useEffect(() => {
    const interval = setInterval(() => {
      const currentTheme = localStorage.getItem("theme")
      setTheme(currentTheme)
    }, 500)

    return () => clearInterval(interval)
  }, [])
  return (
    <>
      <div
        className={` py-5 ${theme == "glassy" ? "bg-resource-footer" : theme === "light" ? "bg-btn" : theme === "dark" ? "bg-btn" : "bg-resource-footer"}`}
      >
        <div className="flex lg:flex-row md:flex-row items-center gap-8 flex-col justify-between container mx-auto">
          <div className="flex gap-4 items-center">
            <p
              className={`mx-3 text-glass-white border-b ${theme == "glassy" ? "border-white" : theme === "light" ? "border-black" : theme === "dark" ? "border-white" : "border-white"}`}
            >
              <a href="mailto:info@visualfolio.co">info@visualfolio.co</a>
            </p>
            <div
              className={`border-r h-6 ${theme == "glassy" ? "border-white" : theme === "light" ? "border-black" : theme === "dark" ? "border-white" : "border-white"}`}
            ></div>
            <p className="text-glass-white">
              <a href="tel:+18315298250">+1 (831) 529 8250</a>
            </p>
          </div>
          <div className="flex gap-8 items-center">
            <div className="w-7 h-7">
              <StaticImage
                className="w-full h-full rounded border border-white"
                src="./instagram.svg"
                alt="visualfolio-instagram"
                placeholder="blurred"
              />
            </div>
            <div className="w-7 h-7">
              <StaticImage
                className="w-full h-full rounded border border-white"
                src="./twitter-x.svg"
                alt="visualfolio-twitter"
                placeholder="blurred"
              />
            </div>

            <div className="w-7 h-7">
              <StaticImage
                className="w-full h-full rounded border border-white"
                src="./linkdin.svg"
                alt="visualfolio-linkdin"
                placeholder="blurred"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
